
<div class="public">
  <v-footer dark height="auto" color="#152939" class="pg-bottom-60 mt-4">
    <v-container class="pa-0">
      <div class="pg-lr-60" style="margin-top: 2%">
        <v-row
          :class="{ 'd-flex flex-column': $vuetify.breakpoint.smAndDown }"
        >
          <v-col cols="12" md="4">
            <v-card dark flat color="#152939" style="margin-left: -45px">
              <div>
                <div class="d-flex">
                  <img
                    src="/assets/public/ucclogo.png"
                    style="top: -12px; position: relative; margin-left: -10px"
                    alt="logo"
                  />
                  <span style="font-size: 18px; padding-left: 10px"
                    >Urban Care Community</span
                  >
                </div>
                <p>
                  Connecting qualified care professionals with care
                  organisations and individuals, ensuring quality care and
                  support for all.
                </p>
              </div>
              <div style="display: flex; gap: 20px">
                <a
                  v-for="profile in profiles"
                  :key="profile.icon"
                  :href="profile.link"
                  target="_blank"
                  style="margin-left: -15px"
                >
                  <v-btn
                    :key="profile.icon"
                    class="white--text"
                    color="white"
                    icon
                  >
                    <v-icon size="24px">{{ profile.icon }}</v-icon>
                  </v-btn>
                </a>
              </div>
            </v-card>
          </v-col>
          <v-col cols="12" md="2">
            <v-card dark flat color="#152939">
              <p>
                <b>GET STARTED</b>
              </p>
              <router-link to="#training"
                >Training & Qualifications</router-link
              >
              <br />
              <router-link to="/care-provider-signup"
                >Care Providers</router-link
              >
              <br />
              <router-link to="/qmo-signup">Monitoring Officer</router-link>
              <br />
              <router-link to="/care-worker-and-nurses-signup"
                >IHP</router-link
              >
              <br />
              <router-link to="/contact-us">Contact Us</router-link>
              <br />
              <router-link to="/faq">FAQ</router-link>
            </v-card>
          </v-col>
          <v-col cols="12" md="2">
            <v-card dark flat color="#152939">
              <p>
                <b>COMPANY</b>
              </p>
              <router-link to="#about">About Us</router-link>
              <br />
              <router-link to="/covid19">COVID19 Reponse</router-link>
              <br />
              <router-link to="/ucc-privacy-policy">Privacy</router-link>
              <br />
              <router-link to="/terms-and-conditions"
                >Terms and Conditions</router-link
              >
            </v-card>
          </v-col>
          <v-col cols="12" md="2">
            <v-card dark flat color="#152939">
              <p>
                <b>RESOURCES</b>
              </p>
              <router-link to="/technology-enabled-care"
                >Technology Enabled Care</router-link
              >
              <br />
              <router-link to="/learning-disability-care-guide"
                >LD Care Guide</router-link
              >
              <br />
              <router-link to="/live-in-care-guide"
                >Live in Care Guide</router-link
              >
              <br />
              <router-link to="/funding-care-guide"
                >Funding Care Guide</router-link
              >
              <br />
              <router-link to="/dementia-care-guide"
                >Dementia Guide</router-link
              >
              <br />
              <router-link to="/nursing-care-guide"
                >Nursing Care Guide</router-link
              >
              <br />
              <router-link to="/policies"
                >Training & Qualifications policies</router-link
              >
            </v-card>
          </v-col>
          <v-col cols="12" md="2">
            <v-card dark flat color="#152939">
              <p class="mb-4">
                <b>CONTACT US</b>
              </p>

              <div class="d-flex align-center mb-2">
                <v-icon small class="mr-2">mdi-phone</v-icon>
                <span>02080545220</span>
              </div>

              <div class="d-flex align-center mb-2">
                <v-icon small class="mr-2">mdi-email</v-icon>
                <a
                  href="mailto:info@urbancarecommunity.com"
                  class="white--text text-decoration-none"
                >
                  info@urbancarecommunity.com
                </a>
              </div>

              <v-row class="mt-3 mb-1 align-start" no-gutters>
                <v-col cols="auto">
                  <v-icon size="20" class="mr-2">mdi-map-marker</v-icon>
                </v-col>
                <v-col>
                  <p class="mb-1">1st Floor,</p>
                  <p class="mb-1">Cranbrook house</p>
                  <p class="mb-1">61 Cranbrook Rd</p>
                  <p class="mb-1">Ilford, IG1 4PG</p>
                  <p class="mb-0">United Kingdom</p>
                </v-col>
              </v-row>
            </v-card>
          </v-col>
        </v-row>
      </div>

      <v-divider
        class="mt-4"
        style="border-color: rgba(255, 255, 255, 0.2)"
      ></v-divider>
      <div class="pg-top-30">
        <p :class="{ 'p-small': $vuetify.breakpoint.smAndDown }">
          © 2017 Urban Care Community is registered in England and Wales
          Number 10739712. The Care Quality Commission (CQC) defines companies
          like Urban Care Community as an introductory agency pursuant to the
          Health & Social Care Act 2008
        </p>
      </div>
    </v-container>
  </v-footer>
</div>
